<div class="scroll-shadow-top">
  <div class="modal-header has-close">
    <div class="title" ngbAutofocus>{{ title }}</div>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="handleCloseModal()"
    >
      <img src="assets/icons/ic-close@3x.svg" alt="" />
    </button>
  </div>
  <div
    class="tabs"
    [class.multiple-tabs]="moderateRiskContent || highRiskContent"
  >
    <div
      class="tab"
      [class.selected]="selectedRiskTab === 0"
      (click)="handleSelectedRisk(0)"
    >
      Low risk
    </div>
    <div
      class="tab"
      [class.selected]="selectedRiskTab === 1"
      (click)="handleSelectedRisk(1)"
      *ngIf="moderateRiskContent"
    >
      Moderate risk
    </div>
    <div
      class="tab"
      [class.selected]="selectedRiskTab === 2"
      (click)="handleSelectedRisk(2)"
      *ngIf="highRiskContent"
    >
      High risk
    </div>
  </div>
</div>
<!--<div class="scroll-shadow-top"></div>-->
<div class="modal-body">
  <div class="managed-content" *ngIf="selectedRiskTab === 0">
    <div class="fna-product-description" [innerHTML]="lowRiskContent"></div>
  </div>
  <div class="managed-content" *ngIf="selectedRiskTab === 1">
    <div
      class="fna-product-description"
      [innerHTML]="moderateRiskContent"
    ></div>
  </div>
  <div class="managed-content" *ngIf="selectedRiskTab === 2">
    <div class="fna-product-description" [innerHTML]="highRiskContent"></div>
  </div>
</div>
<div class="modal-footer scroll-shadow-bottom"></div>
